import React from 'react';
import { useSelector } from 'react-redux';
import CallbackInbox from './CallbackInbox';
import CallbackPending from './CallbackPending';
import CallbackCancelled from './CallbackCancelled';
import CallbackCompleted from './CallbackCompleted';

const CallbackDetailslist = () => {
    const selectedTab = useSelector((state:any)=>{return state.callbackSlice.selectedTab})
    const customViewsIframe = document.querySelector('#customviews-container')!;
    customViewsIframe.setAttribute('style', "height: 0; width: 0;");
    return (
        <React.Fragment>
            <div className="card wrapup-box collapse show mt-3" id="callback">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Callback details</h6>
                </div>
                <div className="card-body callback-autoscroll">
                    {selectedTab === 'Inbox' &&
                        <CallbackInbox />
                    }
                    {selectedTab === 'Pending' &&
                        <CallbackPending />
                    }
                    {selectedTab === 'Cancelled' &&
                        <CallbackCancelled />
                    }
                    {selectedTab === 'Completed' &&
                        <CallbackCompleted />
                    }
                </div>
            </div>
        </React.Fragment>  
    )
}
export default CallbackDetailslist;
